import * as Sentry from "@sentry/react";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

Sentry.init({
  dsn: "https://3024b628e784adf3f22025bb0afc4507@o4512132449501184.ingest.de.sentry.io/4512132468834384",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});

import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, ToastProvider } from '@bala/ui';
import '@bala/ui/tokens.css';
import '@bala/ui/shell.css';
import { AuthProvider } from './auth';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error("Élément #root introuvable dans index.html.");

createRoot(container).render(
  <StrictMode>
    <ThemeProvider storageKey="bala.staff.theme">
      <ToastProvider>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);

// Enregistrement du service worker : le mode hors connexion et l'installation
// sur l'écran d'accueil en dépendent. En développement, il masquerait les
// rechargements à chaud, donc on ne l'active qu'en production.
if ('serviceWorker' in navigator && (import.meta.env.PROD || window.location.search.includes('sw=1'))) {
  const registerSW = () => {
    void navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('[pwa] service worker staff non enregistré :', error);
    });
  };
  if (document.readyState === 'complete') {
    registerSW();
  } else {
    window.addEventListener('load', registerSW);
  }
}
